import { render, staticRenderFns } from "./Dinamica.vue?vue&type=template&id=7c82ace4&scoped=true&"
import script from "./Dinamica.vue?vue&type=script&lang=js&"
export * from "./Dinamica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82ace4",
  null
  
)

export default component.exports